/**
 * @function 	formatCount
 * @desc
 */
export default function(count, singular, plural) {
    if (! plural)
        plural = singular + 's'

    return count + ' ' + (count == 1 ? singular : plural)
}
